import React from "react";
import ReactDOM from "react-dom";

//
import App from "./App";
import reportWebVitals from "./services/web-vitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
